import React, { useCallback } from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FOCUS_BORDER } from "../../config/focusStyles";
import { useInputMode } from "../../utils/hooks/useInputMode";

// ============================================================================
// STYLED COMPONENTS (Legacy CSS compatible)
// ============================================================================

var ContentRowScrollingWrapper = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  -ms-flex-negative: 1;
  flex-shrink: 1;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  width: 100%;
`;

var ContentRowScrollingContent = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  width: 100%;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
`;

var ContentRowTitle = styled.div`
  color: white;
  margin-bottom: 22px;
  font-size: 27px;
  font-weight: 700;
  margin-top: 1rem;
  padding-left: 60px;
  font-family: "AnjomanMax", serif;
`;

var ItemContainer = styled.div`
  padding: 0.75rem;
  width: calc(20% - 1rem);
`;

var ItemCard = styled.div`
  width: 100%;
  min-height: 130px;
  background: #292323;
  border: ${function (props) {
    return props.$focused
      ? FOCUS_BORDER.active
      : FOCUS_BORDER.inactive;
  }};
  border-radius: 16px;
  padding: 2%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
`;

var ItemName = styled.span`
  color: #bfbfbf;
  font-weight: 700;
  font-size: 28px;
  font-family: "AnjomanMax", serif;
`;

var ItemDesc = styled.span`
  color: #8c8c8c;
  font-weight: 500;
  font-size: 18px;
  font-family: "AnjomanMax", serif;
  &:hover {
    color: #b41c20e5;
  }
`;

// ============================================================================
// COMPONENTS
// ============================================================================

var CategoryItem = function (props) {
  var item = props.item;
  var onFocus = props.onFocus;
  var onEnterPress = props.onEnterPress;

  var focusableResult = useFocusable({ onFocus: onFocus, onEnterPress: onEnterPress });
  var focused = focusableResult.focused;
  var ref = focusableResult.ref;
  var focusSelf = focusableResult.focusSelf;

  var inputModeResult = useInputMode();
  var setMouseFocus = inputModeResult.setMouseFocus;
  var handleMouseEnter = useCallback(function () {
    setMouseFocus(true);
    focusSelf();
  }, [focusSelf, setMouseFocus]);

  return (
    <ItemContainer>
      <ItemCard ref={ref} $focused={focused} onMouseEnter={handleMouseEnter} onClick={onEnterPress}>
        <ItemName>{item.name}</ItemName>
        {item.desc && (
          <ItemDesc>
            <span>{item.desc}</span>
          </ItemDesc>
        )}
      </ItemCard>
    </ItemContainer>
  );
};

export var CategoriesSlider = function (props) {
  var categories = props.categories;
  var onFocus = props.onFocus;
  var rowTitle = props.rowTitle;
  var id = props.id;

  var navigate = useNavigate();

  return (
    <React.Fragment>
      <ContentRowTitle>{rowTitle}</ContentRowTitle>
      <ContentRowScrollingWrapper>
        <ContentRowScrollingContent>
          {categories?.map(function (item) {
            return (
              <CategoryItem
                item={item}
                key={item._id}
                onEnterPress={function () {
                  navigate("/" + item.kind + "/" + item.slug);
                }}
                onFocus={onFocus}
              />
            );
          })}
        </ContentRowScrollingContent>
      </ContentRowScrollingWrapper>
    </React.Fragment>
  );
};
